import { format } from 'date-fns'
export const appToday = () => {
  return format(new Date(), 'yyyy-MM-dd_hh_mm_a')
}
export const axiosDownloadable = (res, name) => {
  const url = window.URL.createObjectURL(new Blob([res.data]))
  const link = document.createElement('a')
  link.href = url
  const today = appToday()
  link.setAttribute('download', `${name}_${today}.xlsx`)
  document.body.appendChild(link)
  link.click()
}

export const downloadFromUrl = async (url, name) => {
  try {
    const response = await fetch(url)
    const blob = await response.blob()
    const blobUrl = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = blobUrl
    const today = appToday()
    link.setAttribute('download', `${name}_${today}.xlsx`)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(blobUrl)
  } catch (error) {
    console.error('Error downloading file:', error)
    throw error
  }
}